import { handleRequest } from "../../axios";
import { axiosInstance } from "./JsdhNotifikaceService";
import {
    ADMIN_TECHNIKA_URL,
    ADMIN_TECHNIKA_BY_ID_URL,
    ADMIN_TECHNIKA_FOTOGRAFIE_URL,
    ADMIN_TECHNIKA_JIZDY_URL,
    ADMIN_TECHNIKA_KONTROLY_URL,
    ADMIN_TECHNIKA_KONTROLY_HISTORIE_URL,
    ADMIN_TECHNIKA_KONTROLA_URL,
    ADMIN_TECHNIKA_KONTROLY_PREHLED_URL,
    TECHNIKA_ACTIVE_URL,
    TECHNIKA_DOSTUPNOST_PREHLED_URL,
    TECHNIKA_DOSTUPNOST_ODHLASIT_URL,
    TECHNIKA_DOSTUPNOST_UKONCIT_URL,
} from "../url";
import type { Technika } from "../generated/models/Technika";
import type {
    DostupnostTechnika,
    TechnikaDostupnostPrehled,
    SetDostupnostTechnikaRequest,
} from "../generated/models/DostupnostTechnika";
import type { TechnikaRequest } from "../generated/models/TechnikaRequest";
import type { TechnikaKontrola, CreateTechnikaKontrolaRequest, TechnikaKontrolyOverviewResponse } from "../generated/models/TechnikaKontrola";
import type { JizdaResponse } from "../generated/models/Jizda";
import type { KontrolaStatusResponse } from "../generated/models/Kontrola";

const getAllTechnika = () => {
    return handleRequest<Technika[]>(() =>
        axiosInstance.get(ADMIN_TECHNIKA_URL)
    );
};

const getTechnikaById = (id: number) => {
    return handleRequest<Technika>(() =>
        axiosInstance.get(ADMIN_TECHNIKA_BY_ID_URL(id))
    );
};

const getActiveTechnika = () => {
    return handleRequest<Technika[]>(() =>
        axiosInstance.get(TECHNIKA_ACTIVE_URL)
    );
};

const getActiveTechnikaWithDeviceToken = (deviceToken: string) => {
    return handleRequest<Technika[]>(() =>
        axiosInstance.get(TECHNIKA_ACTIVE_URL, { params: { deviceToken } })
    );
};

const createTechnika = (data: TechnikaRequest) => {
    return handleRequest<Technika>(() =>
        axiosInstance.post(ADMIN_TECHNIKA_URL, data)
    );
};

const updateTechnika = (id: number, data: TechnikaRequest) => {
    return handleRequest<Technika>(() =>
        axiosInstance.put(ADMIN_TECHNIKA_BY_ID_URL(id), data)
    );
};

const deleteTechnika = (id: number) => {
    return handleRequest(() =>
        axiosInstance.delete(ADMIN_TECHNIKA_BY_ID_URL(id))
    );
};

const uploadFotografie = (id: number, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return handleRequest<{ success: boolean; message: string }>(() =>
        axiosInstance.post(ADMIN_TECHNIKA_FOTOGRAFIE_URL(id), formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    );
};

const deleteFotografie = (id: number) => {
    return handleRequest<{ success: boolean; message: string }>(() =>
        axiosInstance.delete(ADMIN_TECHNIKA_FOTOGRAFIE_URL(id))
    );
};

const getKnihaJizd = (id: number) => {
    return handleRequest<JizdaResponse[]>(() =>
        axiosInstance.get(ADMIN_TECHNIKA_JIZDY_URL(id))
    );
};

const getKontrolyOverview = () => {
    return handleRequest<TechnikaKontrolyOverviewResponse>(() =>
        axiosInstance.get(ADMIN_TECHNIKA_KONTROLY_PREHLED_URL)
    );
};

const getKontrolyForTechnika = (id: number) => {
    return handleRequest<KontrolaStatusResponse[]>(() =>
        axiosInstance.get(ADMIN_TECHNIKA_KONTROLY_URL(id))
    );
};

const getKontrolyHistorie = (id: number, typId: number) => {
    return handleRequest<TechnikaKontrola[]>(() =>
        axiosInstance.get(ADMIN_TECHNIKA_KONTROLY_HISTORIE_URL(id, typId))
    );
};

const createTechnikaKontrola = (id: number, data: CreateTechnikaKontrolaRequest) => {
    return handleRequest<TechnikaKontrola>(() =>
        axiosInstance.post(ADMIN_TECHNIKA_KONTROLY_URL(id), data)
    );
};

const updateTechnikaKontrola = (kontrolaId: number, data: CreateTechnikaKontrolaRequest) => {
    return handleRequest<TechnikaKontrola>(() =>
        axiosInstance.put(ADMIN_TECHNIKA_KONTROLA_URL(kontrolaId), data)
    );
};

const deleteTechnikaKontrola = (kontrolaId: number) => {
    return handleRequest(() =>
        axiosInstance.delete(ADMIN_TECHNIKA_KONTROLA_URL(kontrolaId))
    );
};

const getDostupnostPrehled = () => {
    return handleRequest<TechnikaDostupnostPrehled[]>(() =>
        axiosInstance.get(TECHNIKA_DOSTUPNOST_PREHLED_URL)
    );
};

const odhlasitTechniku = (id: number, data: SetDostupnostTechnikaRequest) => {
    return handleRequest<DostupnostTechnika>(() =>
        axiosInstance.post(TECHNIKA_DOSTUPNOST_ODHLASIT_URL(id), data)
    );
};

const ukoncitDostupnost = (dostupnostId: number) => {
    return handleRequest(() =>
        axiosInstance.put(TECHNIKA_DOSTUPNOST_UKONCIT_URL(dostupnostId))
    );
};

const TechnikaServiceApi = {
    getAllTechnika,
    getTechnikaById,
    getActiveTechnika,
    getActiveTechnikaWithDeviceToken,
    createTechnika,
    updateTechnika,
    deleteTechnika,
    uploadFotografie,
    deleteFotografie,
    getKnihaJizd,
    getKontrolyOverview,
    getKontrolyForTechnika,
    getKontrolyHistorie,
    createTechnikaKontrola,
    updateTechnikaKontrola,
    deleteTechnikaKontrola,
    getDostupnostPrehled,
    odhlasitTechniku,
    ukoncitDostupnost,
};

export default TechnikaServiceApi;
